import React, { useEffect, useRef, useState } from 'react';
import { Typography } from 'antd';
import {
  DatabaseOutlined,
  EnvironmentOutlined,
  ExperimentOutlined,
  LaptopOutlined,
  LinkOutlined,
  RiseOutlined,
  TeamOutlined,
} from '@ant-design/icons';
import '../../../Styles/ResearchLabs.css';

const { Title } = Typography;

const impactData = [
  [85, 'Academic Research & Development', ExperimentOutlined],
  [4, 'Hardware/ Software', LaptopOutlined],
  [26, 'Data & Inventory Management', DatabaseOutlined],
  [35, 'Models & Maps Development', EnvironmentOutlined],
  [92, 'Capacity Building', TeamOutlined],
  [61, 'Linkages & Commercialization', LinkOutlined],
  [67, 'Research Impact', RiseOutlined],
];

const CountUp = ({ end, active, duration = 1700 }) => {
  const [value, setValue] = useState(0);

  useEffect(() => {
    if (!active) {
      setValue(0);
      return undefined;
    }

    let frame;
    let startedAt;
    const animate = (time) => {
      if (!startedAt) startedAt = time;
      const progress = Math.min((time - startedAt) / duration, 1);
      const eased = 1 - Math.pow(1 - progress, 3);
      setValue(Math.round(end * eased));
      if (progress < 1) frame = requestAnimationFrame(animate);
    };

    frame = requestAnimationFrame(animate);
    return () => cancelAnimationFrame(frame);
  }, [active, duration, end]);

  return value;
};

const Impact = () => {
  const sectionRef = useRef(null);
  const [active, setActive] = useState(false);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => setActive(entry.isIntersecting),
      { threshold: 0.25 },
    );
    if (sectionRef.current) observer.observe(sectionRef.current);
    return () => observer.disconnect();
  }, []);

  return (
    <section
      ref={sectionRef}
      className="impact-section"
    >
      <div className="impact-overlay">
        <div className="impact-inner">
          <div className="impact-heading">
            <Title level={2}>Impact</Title>
            <div className="impact-heading-line" />
          </div>

          <div className="impact-grid">
            {impactData.map(([value, label, Icon]) => (
              <div className="impact-card" key={label}>
                <div className="impact-card-icon" aria-hidden="true"><Icon /></div>
                <div className="impact-number"><CountUp end={value} active={active} /></div>
                <div className="impact-card-title">{label}</div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default Impact;
